export const sliderFotos = [
  "/Images/Wedding/1.jpg",
  "/Images/Wedding/2.jpg",
  "/Images/Wedding/3.jpg",
  "/Images/Wedding/4.jpg",
  "/Images/Wedding/5.jpg",
  "/Images/Wedding/6.jpg",
  "/Images/Wedding/8.jpg",
  "/Images/Wedding/9.jpg",
  "/Images/Wedding/10.jpg",
  "/Images/Wedding/11.jpg",
  "/Images/Wedding/12.jpg",
  "/Images/Wedding/13.jpg",
  "/Images/Wedding/14.jpg",
  "/Images/Wedding/15.jpg",
  "/Images/Wedding/16.jpg",
  "/Images/Wedding/17.jpg",
  "/Images/Wedding/18.jpg",
  "/Images/Wedding/19.jpg",
  "/Images/Wedding/20.jpg",
  "/Images/Wedding/21.jpg",
  "/Images/Wedding/22.jpg",
  "/Images/Wedding/23.jpg",
  "/Images/Wedding/24.jpg",
  "/Images/Wedding/25.jpg",
  "/Images/Wedding/26.jpg",
  "/Images/Wedding/27.jpg",
  "/Images/Wedding/28.jpg",
  "/Images/Wedding/29.jpg",
  "/Images/Wedding/30.jpg",
  "/Images/Wedding/31.jpg",
  "/Images/Wedding/32.jpg",
  "/Images/Wedding/33.jpg",
  "/Images/Wedding/34.jpg",
  "/Images/Wedding/35.jpg",
  "/Images/Wedding/36.jpg",
  "/Images/Wedding/37.jpg",
  "/Images/Wedding/38.jpg",
  "/Images/Wedding/39.jpg",
  "/Images/Wedding/40.jpg",
  "/Images/Wedding/41.jpg",
  "/Images/Wedding/42.jpg",
  "/Images/Wedding/43.jpg",
  "/Images/Wedding/44.jpg",
  "/Images/Wedding/45.jpg",
  "/Images/Wedding/46.jpg",
  "/Images/Wedding/47.jpg",
  "/Images/Wedding/48.jpg",
  "/Images/Wedding/49.jpg",
  "/Images/Wedding/50.jpg",
  "/Images/Wedding/51.jpg",
  "/Images/Wedding/52.jpg",
  "/Images/Wedding/53.jpg",
  "/Images/Wedding/54.jpg",
  "/Images/Wedding/55.jpg",
  "/Images/Wedding/56.jpg",
  "/Images/Wedding/57.jpg",
  "/Images/Wedding/58.jpg",
  "/Images/Wedding/59.jpg",
  "/Images/Wedding/60.jpg",
  "/Images/Wedding/61.jpg",
  "/Images/Wedding/62.jpg",
  "/Images/Wedding/63.jpg",
  "/Images/Wedding/64.jpg",
  "/Images/Wedding/65.jpg",
  "/Images/Wedding/66.jpg",
  "/Images/Wedding/67.jpg",
  "/Images/Wedding/68.jpg",
  "/Images/Wedding/69.jpg",
  "/Images/Wedding/70.jpg",
  "/Images/Wedding/71.jpg",
  "/Images/Wedding/72.jpg",
  "/Images/Wedding/73.jpg",
  "/Images/Wedding/74.jpg",
  "/Images/Wedding/75.jpg",
  "/Images/Wedding/76.jpg",
  "/Images/Wedding/77.jpg",
  "/Images/Wedding/78.jpg",
  "/Images/Wedding/79.jpg",
  "/Images/Wedding/80.jpg",
  "/Images/Wedding/81.jpg",
  "/Images/Wedding/82.jpg",
  "/Images/Wedding/83.jpg",
  "/Images/Wedding/84.jpg",
  "/Images/Wedding/85.jpg",
  "/Images/Wedding/86.jpg",
  "/Images/Wedding/87.jpg",
  "/Images/Wedding/88.jpg",
  "/Images/Wedding/89.jpg",
  "/Images/Wedding/90.jpg",
  "/Images/Wedding/91.jpg",
  "/Images/Wedding/92.jpg",
  "/Images/Wedding/93.jpg",
  "/Images/Wedding/94.jpg",
  "/Images/Wedding/95.jpg",
  "/Images/Wedding/96.jpg",
  "/Images/Wedding/97.jpg",
  "/Images/Wedding/98.jpg",
  "/Images/Wedding/99.jpg",
  "/Images/Wedding/100.jpg",
  "/Images/Wedding/101.jpg",
  "/Images/Wedding/102.jpg",
  "/Images/Wedding/103.jpg",
  "/Images/Wedding/104.jpg",
  "/Images/Wedding/105.jpg",
  "/Images/Wedding/106.jpg",
  "/Images/Wedding/107.jpg",
  "/Images/Wedding/108.jpg",
  "/Images/Wedding/109.jpg",
  "/Images/Wedding/110.jpg",
  "/Images/Wedding/111.jpg",
  "/Images/Wedding/112.jpg",
  "/Images/Wedding/113.jpg",
  "/Images/Wedding/114.jpg",
  "/Images/Wedding/115.jpg",
  "/Images/Wedding/116.jpg",
  "/Images/Wedding/117.jpg",
  "/Images/Wedding/118.jpg",
  "/Images/Wedding/119.jpg",
  "/Images/Wedding/120.jpg",
  "/Images/Wedding/121.jpg",
  "/Images/Wedding/122.jpg",
  "/Images/Wedding/123.jpg",
  "/Images/Wedding/124.jpg",
  "/Images/Wedding/125.jpg",
  "/Images/Wedding/126.jpg",
  "/Images/Wedding/127.jpg",
  "/Images/Wedding/128.jpg",
  "/Images/Wedding/129.jpg",
  "/Images/Wedding/130.jpg",
  "/Images/Wedding/131.jpg",
  "/Images/Wedding/132.jpg",
  "/Images/Wedding/133.jpg",
  "/Images/Wedding/134.jpg",
  "/Images/Wedding/135.jpg",
  "/Images/Wedding/136.jpg",
  "/Images/Wedding/137.jpg",
  "/Images/Wedding/138.jpg",
  "/Images/Wedding/139.jpg",
  "/Images/Wedding/140.jpg",
  "/Images/Wedding/141.jpg",
  "/Images/Wedding/142.jpg",
  "/Images/Wedding/143.jpg",
  "/Images/Wedding/144.jpg",
  "/Images/Wedding/145.jpg",
  "/Images/Wedding/146.jpg",
  "/Images/Wedding/147.jpg",
  "/Images/Wedding/148.jpg",
  "/Images/Wedding/149.jpg",
  "/Images/Wedding/150.jpg",
  "/Images/Wedding/151.jpg",
  "/Images/Wedding/152.jpg",
  "/Images/Wedding/153.jpg",
  "/Images/Wedding/154.jpg",
  "/Images/Wedding/155.jpg",
  "/Images/Wedding/156.jpg",
  "/Images/Wedding/157.jpg",
  "/Images/Wedding/158.jpg",
  "/Images/Wedding/159.jpg",
  "/Images/Wedding/160.jpg",
  "/Images/Wedding/161.jpg",
  "/Images/Wedding/162.jpg",
  "/Images/Wedding/163.jpg",
  "/Images/Wedding/164.jpg",
  "/Images/Wedding/165.jpg",
  "/Images/Wedding/166.jpg",
  "/Images/Wedding/167.jpg",
  "/Images/Wedding/168.jpg",
  "/Images/Wedding/169.jpg",
  "/Images/Wedding/170.jpg",
  "/Images/Wedding/171.jpg",
  "/Images/Wedding/172.jpg",
  "/Images/Wedding/173.jpg",
  "/Images/Wedding/174.jpg",
  "/Images/Wedding/175.jpg",
  "/Images/Wedding/176.jpg",
  "/Images/Wedding/177.jpg",
  "/Images/Wedding/178.jpg",
  "/Images/Wedding/179.jpg",
  "/Images/Wedding/180.jpg",
  "/Images/Wedding/181.jpg",
  "/Images/Wedding/182.jpg",
  "/Images/Wedding/183.jpg",
  "/Images/Wedding/184.jpg",
  "/Images/Wedding/185.jpg",
  "/Images/Wedding/186.jpg",
  "/Images/Wedding/187.jpg",
  "/Images/Wedding/188.jpg",
  "/Images/Wedding/189.jpg",
  "/Images/Wedding/190.jpg",
  "/Images/Wedding/191.jpg",
  "/Images/Wedding/192.jpg",
  "/Images/Wedding/193.jpg",
  "/Images/Wedding/194.jpg",
  "/Images/Wedding/195.jpg",
  "/Images/Wedding/196.jpg",
  "/Images/Wedding/197.jpg",
  "/Images/Wedding/198.jpg",
  "/Images/Wedding/199.jpg",
  "/Images/Wedding/200.jpg",
  "/Images/Wedding/201.jpg",
  "/Images/Wedding/202.jpg",
  "/Images/Wedding/203.jpg",
  "/Images/Wedding/204.jpg",
  "/Images/Wedding/205.jpg",
  "/Images/Wedding/206.jpg",
  "/Images/Wedding/207.jpg",
  "/Images/Wedding/208.jpg",
  "/Images/Wedding/209.jpg",
  "/Images/Wedding/210.jpg",
  "/Images/Wedding/211.jpg",
  "/Images/Wedding/212.jpg",
  "/Images/Wedding/213.jpg",
  "/Images/Wedding/214.jpg",
  "/Images/Wedding/215.jpg",
  "/Images/Wedding/216.jpg",
  "/Images/Wedding/217.jpg",
  "/Images/Wedding/218.jpg",
  "/Images/Wedding/219.jpg",
  "/Images/Wedding/220.jpg"
];